import { Theme } from '@mui/material/styles';
// ----------------------------------------------------------------------

export default function DataGrid(theme: Theme) {
    return {
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    border: `1px solid transparent`,
                    '&.no-header-radius': {
                        '& .MuiDataGrid-columnHeaders': {
                            borderTopLeftRadius: 0,
                            borderTopRightRadius: 0,
                        },
                    },
                    '&.transparent': {
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: 'transparent',
                        },
                        '& .MuiDataGrid-cell': {
                            backgroundColor: 'transparent',
                            borderBottom: `1px solid ${theme.palette.divider}`,
                        },
                        '& .MuiDataGrid-footerContainer': {
                            backgroundColor: 'transparent',
                            borderTop: `1px solid ${theme.palette.divider}`,
                        },
                    },
                    '& .MuiDataGrid-footerContainer': {
                        backgroundColor: theme.palette.background.paper,
                        borderBottomLeftRadius: 16,
                        borderBottomRightRadius: 16,
                        borderTop: `1px dashed ${theme.palette.divider}`,
                    },
                    '& .MuiTablePagination-root': {
                        borderTop: 0,
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        backgroundColor: theme.palette.background.neutral,
                        borderTopLeftRadius: 16,
                        borderTopRightRadius: 16,
                        color: theme.palette.text.secondary,
                    },
                    '& ::-webkit-scrollbar-track': {
                        backgroundColor: theme.palette.background.paper,
                    },
                    '& ::-webkit-scrollbar-thumb': {
                        backgroundColor: theme.palette.background.default,
                    },
                    '& .MuiDataGrid-scrollbar': {
                        backgroundColor: theme.palette.background.paper,
                    },
                },
                cell: {
                    borderBottom: `1px dashed ${theme.palette.divider}`,
                    backgroundColor: theme.palette.background.paper,
                },
                columnSeparator: {
                    color: theme.palette.divider,
                },
                toolbarContainer: {
                    padding: theme.spacing(2),
                    backgroundColor: theme.palette.background.neutral,
                    '& .MuiButton-root': {
                        marginRight: theme.spacing(1.5),
                        color: theme.palette.text.primary,
                        '&:hover': {
                            backgroundColor: theme.palette.action.hover,
                        },
                    },
                },
                paper: {
                    boxShadow: theme.customShadows.dropdown,
                },
                menu: {
                    '& .MuiPaper-root': {
                        boxShadow: theme.customShadows.dropdown,
                    },
                    '& .MuiMenuItem-root': {
                        ...theme.typography.body2,
                        '& .MuiListItemIcon-root': {
                            minWidth: 'auto',
                        },
                    },
                },
                panelFooter: {
                    padding: theme.spacing(2),
                    justifyContent: 'flex-end',
                    borderTop: `1px solid ${theme.palette.divider}`,
                    '& .MuiButton-root': {
                        '&:first-of-type': {
                            marginRight: theme.spacing(1.5),
                            color: theme.palette.text.primary,
                            '&:hover': {
                                backgroundColor: theme.palette.action.hover,
                            },
                        },
                        '&:last-of-type': {
                            color: theme.palette.common.white,
                            backgroundColor: theme.palette.primary.main,
                            '&:hover': {
                                backgroundColor: theme.palette.primary.dark,
                            },
                        },
                    },
                },
                filterForm: {
                    padding: theme.spacing(1.5, 0),
                    '& .MuiFormControl-root': {
                        margin: theme.spacing(0, 0.5),
                    },
                    '& .MuiInput-root': {
                        marginTop: theme.spacing(3),
                        '&::before, &::after': {
                            display: 'none',
                        },
                        '& .MuiNativeSelect-select, .MuiInput-input': {
                            ...theme.typography.body2,
                            padding: theme.spacing(0.75, 1),
                            borderRadius: theme.shape.borderRadius,
                            backgroundColor: theme.palette.background.neutral,
                        },
                        '& .MuiSvgIcon-root': {
                            right: 4,
                        },
                    },
                },
            },
        },
    };
}
